var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMaterialSymbolsSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols:search"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.5616 22.2463L14.092 15.7767C13.5785 16.1875 12.988 16.5127 12.3205 16.7523C11.653 16.9919 10.9427 17.1117 10.1896 17.1117C8.32407 17.1117 6.74535 16.4654 5.45348 15.1729C4.16161 13.8803 3.51533 12.3016 3.51465 10.4367C3.51465 8.57114 4.16093 6.99242 5.45348 5.70055C6.74603 4.40868 8.32476 3.7624 10.1896 3.76172C12.0552 3.76172 13.6343 4.408 14.9268 5.70055C16.2194 6.9931 16.8653 8.57183 16.8646 10.4367C16.8646 11.1898 16.7448 11.9001 16.5052 12.5676C16.2656 13.2351 15.9404 13.8256 15.5296 14.339L21.9993 20.8086L20.5616 22.2463ZM10.1896 15.0579C11.4733 15.0579 12.5646 14.6088 13.4635 13.7105C14.3624 12.8123 14.8115 11.7211 14.8108 10.4367C14.8108 9.15306 14.3617 8.06213 13.4635 7.16392C12.5653 6.2657 11.474 5.81625 10.1896 5.81556C8.90599 5.81556 7.81506 6.26502 6.91684 7.16392C6.01863 8.06282 5.56918 9.15375 5.56849 10.4367C5.56849 11.7204 6.01794 12.8116 6.91684 13.7105C7.81574 14.6094 8.90668 15.0586 10.1896 15.0579Z",
    fill: "#0073FF"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialSymbolsSearch);
export default __webpack_public_path__ + "static/media/material-symbols_search.dd3cd1e84d990a9a9b79101fecd3adbe.svg";
export { ForwardRef as ReactComponent };